import { useParams } from "react-router-dom";
import BillingOrderDetails from "./billing-order-details";
import OrderReceipt from "./order-receipt";

const BillingReceiptRouter = () => {
  const { invoicenumber } = useParams<{ invoicenumber: string }>();
  return /^order-/i.test(invoicenumber || "") ? <OrderReceipt /> : <BillingOrderDetails />;
};

export default BillingReceiptRouter;
